define('views/quick-add-view',[
  'jquery',
  'settings',
  'rivets',

  'views/quick-cart',

  'connections/cart-connection',

  'utils/validate-box-items',
  'utils/view'
], function ($, settings, rivets, QuickCart, CartConnection, validateBoxItems, View) {
  var QuickAddView = (function () {
    function QuickAddView() {}

    QuickAddView.prototype.init = function () {
      this.form = $('#quickadd-form');
      this.list = [];
      this.quickAddApiUrl = settings.quickAddApiUrl;
      this.quickAddListApiUrl = settings.quickAddListApiUrl;
      this.addToCartBtn = $('.quickadd__addcart-btn');
      this.rivetprops = { generalError: null, loading: false };
      this.hasError = true;
      this.postCsvBtn = $('#quickadd-csv-button');
    };

    QuickAddView.prototype.initForm = function () {
      var self = this;
      var $input = this.form.find('#quickadd-sku-input');
      var $amount = this.form.find('#quickadd-amount-input');

      $input.on('click', function () {
        $(this).select();
      });

      var handleError = function (res, status, error) {
        var message = res.responseJSON && res.responseJSON.message ? res.responseJSON.message : error;

        self.rivetprops.generalError = message;
      };

      var handleSuccess = function (data) {
        if (!(data.id || data.sku)) {
          handleError(data, 'error', 'No data returned');
          return;
        }

        self.list.push(data);
      };

      var always = function () {
        $input.focus();
        self.updateErrors();
        self.rivetprops.loading = false;
      };

      this.form.on('submit', function (e) {
        e.preventDefault();
        self.rivetprops.generalError = null;

        var skuText = $input.val();
        var generalError = self.invalidSku(skuText);

        if (generalError) {
          self.rivetprops.generalError = generalError;
          return;
        }

        self.rivetprops.loading = true;
        $.ajax({
          url: self.quickAddApiUrl.replace(':sku', skuText) + '?quantity=' + ($amount.val() || '1'),
          type: 'GET',
          success: handleSuccess,
          error: handleError,
          complete: always
        });
      });

      $('.quickadd').fadeIn();
    };

    QuickAddView.prototype.initCsv = function () {
      this.initCsvButton();
      this.initCsvDropZone();
    };

    QuickAddView.prototype.initCsvButton = function () {
      var self = this;

      $('#quickadd__file-input').on('change', function (e) {
        self.postCsv(e.originalEvent.target.files[0]);

        if ($(this).val() !== '') $(this).val('');
      });
    };

    QuickAddView.prototype.initCsvDropZone = function () {
      var $dropzone = $('#quickadd-dropzone');
      var self = this;

      function preventDefault(e) {
        e.stopPropagation();
        e.preventDefault();
      }

      $(document).on('dragenter dragleave', function (e) {
        preventDefault(e);
        $dropzone.toggleClass('quickadd__dropzone--active');
      });

      $(document).on('dragover', function (e) {
        preventDefault(e);
      });

      $(document).on('drop', function (e) {
        preventDefault(e);
        $dropzone.removeClass('quickadd__dropzone--active');

        var dt = e.originalEvent.dataTransfer;
        var file = dt.files[0];

        self.postCsv(file);
      });
    };

    QuickAddView.prototype.postCsv = function (file) {
      if (!file) return;

      var self = this;
      var filereader = new FileReader();

      filereader.onload = function (loadEvent) {
        var handleSuccess = function (data) {
          if (!data || !data.length) {
            handleError(data, 'error', 'Server returned empty array. Check file format.');
            return;
          }

          $.each(data, function () {
            self.list.push(this);
          });
        };

        var handleError = function (res, status, error) {
          self.rivetprops.generalError = error;
        };

        var always = function () {
          self.rivetprops.loading = false;
          self.updateErrors();
        };

        self.rivetprops.loading = true;
        self.rivetprops.generalError = null;

        $.ajax({
          url: self.quickAddListApiUrl,
          method: 'POST',
          data: { csv: loadEvent.target.result },
          success: handleSuccess,
          error: handleError,
          complete: always
        });
      };

      filereader.readAsDataURL(file);
    };

    QuickAddView.prototype.updateErrors = function () {
      var self = this;

      if (!this.list.length) {
        this.hasError = true;
        return;
      }

      this.hasError = false;

      $.each(this.list, function (i, item) {
        if (item.error) {
          self.hasError = true;
        }
      });
    };

    QuickAddView.prototype.invalidSku = function (text) {
      var segments = text.split('-');

      if (segments.length !== 1 && segments.length !== 3) return 'xxx-xxx-xx';

      for (var i = segments.length - 1; i >= 0; i--) {
        if (!segments[i] || segments[i] === '') return 'xxx-xxx-xx';
      }

      return false;
    };

    QuickAddView.prototype.initRivets = function () {
      rivets.bind($('#quickadd-module'), {
        list: this.list,
        props: this.rivetprops,
        remove: this.removeSku(),
        addtocart: this.addToCart(),
        downloadCSV: this.downloadCSV(),
        activateUpdateInput: this.activateUpdateInput()
      });
    };

    QuickAddView.prototype.activateUpdateInput = function () {
      var self = this;

      return function (e, rvEl) {
        var input = $(this).find('.quickadd__change-qty-input');

        input.addClass('active').focus();
        input.on('blur', function () {
          var item = self.list[rvEl.index];
          if (item.boxItems > 0) {
            $(this).attr('step', item.boxItems);
            validateBoxItems($(this));
            self.list[rvEl.index].quantity = $(this).val();
          }
          input.off('blur input');
          input.removeClass('active');
        });

        input.on('input', function () {
          var line = self.list[rvEl.index];
          line.quantity = input.val();
        });
      };
    };

    QuickAddView.prototype.downloadCSV = function () {
      return function () {
        var a = document.createElement('a');
        var file = new Blob(['sku;quantity\nxxxx-xx-xx;10'], { type: 'csv' });
        var filename = 'template.csv';

        if (window.navigator.msSaveOrOpenBlob)
          // IE10+
          window.navigator.msSaveOrOpenBlob(file, filename);
        else {
          // Others
          var url = URL.createObjectURL(file);
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          }, 0);
        }
      };
    };

    QuickAddView.prototype.removeSku = function () {
      var self = this;

      return function (e, el) {
        self.list.splice(el.index, 1);
        self.updateErrors();
      };
    };

    QuickAddView.prototype.flashErrorLines = function () {
      if (this.list.length < 1) return;

      $('.quickadd__errortext').each(function () {
        $(this).fadeOut(150).fadeIn(150);
      });
    };

    QuickAddView.prototype.addToCart = function () {
      var self = this;

      return function () {
        if (self.hasError) return self.flashErrorLines();

        var itemsToAdd = $.map(self.list, function (line, i) {
          return {
            sku: line.sku,
            quantity: line.quantity,
            size: line.sizeLabel
          };
        });

        CartConnection.add(itemsToAdd).then(function (res) {
          self.list.splice(0, self.list.length);
          self.updateErrors();
          QuickCart.printTotalQuantity(res);
        });
      };
    };

    return QuickAddView;
  })();

  return View('QuickAddView', function () {
    var view = new QuickAddView();

    view.init();
    view.initCsv();
    view.initForm();
    view.initRivets();
  });
});

